import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { flexCenter, palette, flexColumn, flexRow } from '../../constants/styles';
import { withRouter } from 'react-router';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

const OPTIONS_HEIGHT = 70;

const StyledOptionCardContent = styled.div`
  background-color: white;
  width: 95%;
  align-self: flex-end;
  border-top: 1px solid ${palette.silver};
  border-left: 1px solid ${palette.silver};
  border-bottom: 1px solid ${palette.silver};
  border-radius: 0px 8px 8px 0px;
  width: 95%;
  height: ${OPTIONS_HEIGHT}px;
  ${({ expanded }) =>
    expanded &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10000;
      background-color: white;
      width: 100vw;
      height: 100vh;
      border: none;
    `}
  ${({ small }) =>
    small &&
    css`
      height: 40px;
    `}
`;

const StyledDetailsTitle = css`
  align-self: flex-start;
  justify-self: center;
`;
const StyledOptionCardBackground = styled.div`
  border-radius: 8px 8px 8px 8px;
  background-color: ${({ accentColor }) => accentColor};
  border: 1px solid ${palette.silver};
  ${flexCenter}
  flex-direction: column;
  height: ${OPTIONS_HEIGHT}px;
  width: 100%;
  ${({ expanded }) =>
    expanded &&
    css`
      width: 100%;
    `}
  ${({ small }) =>
    small &&
    css`
      height: 40px;
    `}
  ${({ styles }) => styles}
`;

const StyledDetails = styled.div`
  ${flexColumn}
  background-color: white;
`;

const StyledClosedCard = styled.div`
  cursor: pointer;
  padding: 10px 10px;
  ${({ small }) =>
    small &&
    css`
      ${flexRow}
      height: 40px;
      padding-top: 6px;
      padding-left: 6px;
      padding-bottom: 0px;
      padding-right: 10px;
    `}
`;

const StyledCloseIcon = css`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const StyledSubtitle = styled.div`
  ${flexRow}
  width: 100%;
  justify-content: space-between;
`;

const StyledGradient = styled.div`
  background: linear-gradient(transparent, white);
  width: 100%;
  height: 50px;
  position: relative;
  height: 50px;
  bottom: 50px;
  ${({ opposite }) =>
    opposite &&
    css`
      position: relative;
      top: 10px;
      bottom: unset;
      background: linear-gradient(white, transparent);
    `}
`;

const StyledTitle = styled.div`
  height: fit-content;
  background-color: white;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-bottom: 0px;
  margin-right: 50px;
  margin-left: 50px;
  line-height: 1.5;
`;

const StyledContent = styled.div`
  overflow: scroll;
  height: 80vh;
  max-width: 500px;
  align-self: center;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 10vh;
`;

class OptionCard extends Component {
  state = {
    displayingDetails: false,
  };

  render() {
    const {
      children,
      styles,
      accentColor,
      title,
      subtitle,
      expandedTitle,
      showMasInfo,
      small,
    } = this.props;
    const { displayingDetails } = this.state;
    return (
      <Fragment>
        <StyledOptionCardBackground
          styles={styles}
          accentColor={accentColor}
          onClick={
            !displayingDetails
              ? () => {
                  this.setState({ displayingDetails: true });
                  // this.props.history.push(1');,
                }
              : () => null
          }
          expanded={displayingDetails}
          small={small}
        >
          <StyledOptionCardContent expanded={displayingDetails} small={small}>
            {!displayingDetails && (
              <StyledClosedCard small={small}>
                <Title
                  level={4}
                  align="center"
                  style={{
                    lineHeight: 1.4,
                    color: '#022759',
                    textAlign: 'left',
                    marginTop: '0',
                    marginBottom: '0',
                  }}
                >
                  {title}
                </Title>
                <StyledSubtitle>
                  {subtitle}
                  {showMasInfo && (
                    <Text
                      type="body1"
                      color={palette.terciaryColor}
                      style={{ textDecoration: 'underline' }}
                    >
                      MÁS INFO
                    </Text>
                  )}
                </StyledSubtitle>
              </StyledClosedCard>
            )}
            {displayingDetails && (
              <StyledDetails>
                <Icon
                  icon="cross2"
                  color={palette.basicGray}
                  size={50}
                  style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }}
                  styles={StyledCloseIcon}
                  onClick={() => {
                    this.setState({ displayingDetails: false });
                    this.props.history.push('#detalles');
                  }}
                />
                <StyledTitle>
                  <Title
                    level={3}
                    align="center"
                    style={{
                      lineHeight: 1.5,
                      color: '#022759',
                    }}
                  >
                    {expandedTitle ? expandedTitle : title}
                  </Title>
                </StyledTitle>
                <StyledContent className="option-content">
                  {children}
                  <div style={{ width: '100%', height: '12vh' }}></div>
                </StyledContent>
              </StyledDetails>
            )}
          </StyledOptionCardContent>
        </StyledOptionCardBackground>
      </Fragment>
    );
  }
}

OptionCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  styles: PropTypes.array,
  accentColor: PropTypes.string,
  title: PropTypes.string,
  showMasInfo: PropTypes.bool,
  subtitle: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

OptionCard.defaultProps = {
  styles: [],
  showMasInfo: true,
  title: 'untitledOption',
  accentColor: palette.primaryColor,
  subtitle: '',
};

export default withRouter(OptionCard);
